"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
var _templateObject, _templateObject2;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var useStyles = function useStyles(props) {
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    themeColors = _useContext.themeColors;
  var ccMobileLandscapeViewStyle = (0, _react.useMemo)(function () {
    var landscapeImageRotate = (0, _css.keyframes)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        0% { transform: rotate(0deg); }\n        25% { transform: rotate(45deg); }\n        75% { transform: rotate(45deg); }\n        100% { transform: rotate(0deg); }\n    "])));
    var landscapeImageV = (0, _css.keyframes)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        0% { opacity: 0; }\n        25% { opacity: 0; }\n        50% { opacity: 1; }\n        75% { opacity: 0; }\n        100% { opacity: 0; }\n    "])));
    var svgProps = function svgProps() {
      return {
        position: 'relative',
        height: '60%',
        top: '20%',
        width: '75%',
        animationName: landscapeImageRotate,
        animationDuration: '2.5s',
        animationIterationCount: 'infinite',
        '.path1': {
          fill: 'none',
          stroke: themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.light,
          strokeWidth: 11,
          strokeLinecap: 'square',
          strokeMiterlimit: 10
        },
        '.path2': {
          fill: 'none',
          stroke: themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.light,
          strokeWidth: 11,
          strokeMiterlimit: 10,
          opacity: 0,
          animationName: landscapeImageV,
          animationDuration: '2.5s',
          animationIterationCount: 'infinite'
        },
        '.path3': {
          fill: themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.light
        }
      };
    };
    var ccMobileLandscapeView = (0, _css.css)({
      display: 'block',
      background: themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.main,
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 92147483647,
      textAlign: 'center',
      svg: _objectSpread({}, svgProps())
    });
    var ccMobileLandscapeViewMessage = (0, _css.css)({
      display: 'block',
      position: 'absolute',
      color: themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.light,
      left: 0,
      right: 0,
      top: '82%',
      marginLeft: 'auto',
      marginRight: 'auto',
      fontFamily: 'AlmoniNeon',
      fontSize: '1.5rem',
      maxWidth: '45%'
    });
    return {
      ccMobileLandscapeView: ccMobileLandscapeView,
      ccMobileLandscapeViewMessage: ccMobileLandscapeViewMessage
    };
  }, [themeColors]);
  return {
    'cc-MobileLandscapeView': ccMobileLandscapeViewStyle.ccMobileLandscapeView,
    'cc-MobileLandscapeViewMessage': ccMobileLandscapeViewStyle.ccMobileLandscapeViewMessage
  };
};
exports.useStyles = useStyles;
var _default = useStyles;
exports.default = _default;